module.exports = __webpack_public_path__ + "static/media/img-goal-7.8bb9f2c2.jpg";